module.exports = __webpack_public_path__ + "img/herrieden_hochaltar.9dabf416.jpg";